var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "monitoring"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_7417",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_7417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "monitoring_2",
    d: "M4.5625 25.4375V24.0938L5.4375 23.2188V25.4375H4.5625ZM9.5625 25.4375V19.0938L10.4375 18.2188V25.4375H9.5625ZM14.5625 25.4375V18.2188L15.4375 19.125V25.4375H14.5625ZM19.5625 25.4375V19.125L20.4375 18.25V25.4375H19.5625ZM24.5625 25.4375V14.0938L25.4375 13.2188V25.4375H24.5625ZM4.5625 17.8125V16.5938L12.5 8.65625L17.5 13.6562L25.4375 5.71875V6.9375L17.5 14.875L12.5 9.875L4.5625 17.8125Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.afe3f653.svg";
export { ForwardRef as ReactComponent };